import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/PhotoGallery.css";

const importAllImages = (requireContext) => requireContext.keys().map(requireContext);

const images = importAllImages(require.context("../imgs/gallery", false, /\.(png|jpe?g|svg)$/));
const airbnbIcon = require("../imgs/icon/airbnb.png");
const bookingcomIcon = require("../imgs/icon/booking.png");

const PhotoGallery = () => {
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => setSelectedImage(image);
  const handleCloseModal = () => setSelectedImage(null);

  const renderIcons = () => (
    <div className="icon-container mobile-icon" style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', gap: '20px' }}>
      <div className="icon" style={{ cursor: 'pointer' }} onClick={() => window.open('https://www.booking.com/Share-3IdcLz', '_blank')}>
        <img src={bookingcomIcon} alt="Icon Booking.com" style={{ width: '44px', height: '40px' }} />
      </div>
      <div className="icon" style={{ cursor: 'pointer' }} onClick={() => window.open('https://www.airbnb.jp/rooms/1335947108229180506?guests=1&adults=1&s=67&unique_share_id=9a5fd18c-b849-48f4-8382-b99a6d57e886', '_blank')}>
        <img src={airbnbIcon} alt="Icon Airbnb" style={{ width: '39px', height: '40px' }} />
      </div>
    </div>
  );

  return (
    <div className="gallery-container">
      <header className="header">
        <div id="top" className="logo" onClick={() => navigate("/")}>
          NAKAYAMA VILLA
        </div>
        {renderIcons()}
      </header>
      <h1 className="gallery-title">Photo Gallery</h1>
      <div className="photo-grid">
        {images.map((src, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(src)}
          >
            <img src={src} alt={`Gallery Image ${index + 1}`} className="photo" />
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="modal" onClick={handleCloseModal}>
          <div className="modal-content">
            <img src={selectedImage} alt="Selected" className="modal-image" />
          </div>
        </div>
      )}
    </div>
  );
};

export default PhotoGallery;
